// import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
// import type { ListItemProps } from '@mui/material'
// import { Box, Button, Collapse, IconButton, ListItem, ListItemIcon, Typography } from '@mui/material'
// import type { FC, ReactNode } from 'react'
// import { useEffect, useState } from 'react'
// import { NavLink as RouterLink } from 'react-router-dom'
// import ChevronDownIcon from '../../icons/ChevronDown'
// import ChevronUpIcon from '../../icons/ChevronUp'
// import { useMemo } from 'react'
// import { useTheme, Theme } from '@mui/material/styles'
// import useMediaQuery from '@mui/material/useMediaQuery'

// interface NavItemProps extends ListItemProps {
//     active?: boolean
//     children?: ReactNode
//     depth: number
//     icon?: any
//     info?: ReactNode
//     open?: boolean
//     path?: string
//     label?: string
//     hover?: string
//     tooltip?: string
//     collapsed?: boolean
//     setCollapsed: any
// }

// const NavItem: FC<NavItemProps> = ({
//     active = false,
//     children,
//     depth,
//     icon,
//     info,
//     open: openProp = false,
//     path,
//     label,
//     hover,
//     collapsed,
//     setCollapsed,
//     tooltip,
//     ...other
// }) => {
//     const [open, setOpen] = useState<boolean>(openProp)
//     const [showPopUp, setShowPopUp] = useState(false)
//     const handleToggle = (): void => setOpen((prevOpen) => !prevOpen)
//     const [showTooltipKey, setShowTooltipKey] = useState<any>()
//     const theme = useTheme<Theme>()
//     const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

//     if (children) {
//         return (
//             <Box sx={{ position: 'relative' }}>
//                 <ListItem
//                     onClick={() => {
//                         collapsed && setOpen(true)
//                         setCollapsed(collapsed && false)
//                     }}
//                     disableGutters
//                     sx={{
//                         display: 'flex',
//                         alignItems: 'center',
//                         py: 0,
//                         width: '100%',
//                         position: 'relative',
//                         background: active ? '#132854' : 'transparent',
//                         transition: 'background 0.2s',
//                     }}
//                     {...other}
//                     onMouseEnter={() => setShowTooltipKey(label)}
//                     onMouseLeave={() => setShowTooltipKey(null)}
//                 >
//                     {/* Vertical bar for active state */}
//                     <Box
//                         sx={{
//                             width: '3px',
//                             height: '100%',
//                             background: active ? '#E29346' : 'transparent',
//                             position: 'absolute',
//                             left: 0,
//                             top: 0,
//                             bottom: 0,
//                             transition: 'background 0.2s',
//                         }}
//                     />
//                     <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
//                         <Button
//                             endIcon={!collapsed && (!open ? <ChevronDownIcon /> : <ChevronUpIcon />)}
//                             onClick={handleToggle}
//                             sx={{
//                                 display: 'flex',
//                                 gap: '10px',
//                                 fontWeight: 'fontWeightMedium',
//                                 justifyContent: 'center',
//                                 fontSize: '13px',
//                                 textAlign: 'left',
//                                 textTransform: 'none',
//                                 width: '100%',
//                                 alignItems: 'center',
//                                 ...(active && { color: '#E4933D' }),
//                                 ...(collapsed && {
//                                     width: 'fit-content',
//                                     margin: 'auto',
//                                     backgroundColor: 'transparent',
//                                 }),
//                             }}
//                             variant="text"
//                         >
//                             <Box>
//                                 {icon && (
//                                     <ListItemIcon
//                                         sx={{
//                                             color: !active ? 'white' : '#E4933D',
//                                             alignItems: 'center',
//                                             textAlign: 'center',
//                                             ...(collapsed && active && { borderRight: '2px solid #E4933D' }),
//                                         }}
//                                     >
//                                         {icon}
//                                     </ListItemIcon>
//                                 )}
//                             </Box>
//                             {!collapsed && <Box sx={{ flexGrow: 1 }}>{label}</Box>}
//                             {info}
//                         </Button>
//                     </Box>
//                     {!collapsed && <Collapse in={open}>{children}</Collapse>}
//                 </ListItem>
//                 {tooltip && (
//                     <Box
//                         sx={{
//                             display: showTooltipKey === label ? 'block' : 'none',
//                             position: 'absolute',
//                             bgcolor: 'rgba(30,30,30,.8)',
//                             zIndex: '1600',
//                             p: '10px',
//                             borderRadius: '4px',
//                             color: 'white',
//                             fontSize: '10px',
//                             fontWeight: '500',
//                         }}
//                     >
//                         {tooltip}
//                     </Box>
//                 )}
//             </Box>
//         )
//     } else {
//         return (
//             <Box sx={{ position: 'relative' }}>
//                 <ListItem
//                     disableGutters
//                     sx={{
//                         display: 'flex',
//                         alignItems: 'center',
//                         py: 0,
//                         position: 'relative',
//                         background: active ? '#132854' : 'transparent',
//                         transition: 'background 0.2s',
//                     }}
//                     {...other}
//                     onMouseEnter={() => setShowTooltipKey(label)}
//                     onMouseLeave={() => setShowTooltipKey(null)}
//                 >
//                     {/* Vertical bar for active state */}
//                     <Box
//                         sx={{
//                             width: '3px',
//                             height: '100%',
//                             background: active ? '#E29346' : 'transparent',
//                             position: 'absolute',
//                             left: 0,
//                             top: 0,
//                             bottom: 0,
//                             transition: 'background 0.2s',
//                         }}
//                     />
//                     <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', gap: 2, paddingRight: '4px' }}>
//                         <Button
//                             component={path && RouterLink}
//                             sx={{
//                                 display: 'flex',
//                                 gap: '10px',
//                                 fontWeight: 'fontWeightMedium',
//                                 justifyContent: 'center',
//                                 fontSize: '13px',
//                                 textAlign: 'left',
//                                 textTransform: 'none',
//                                 width: '100%',
//                                 alignItems: 'center',
//                                 ...(path === window.location.pathname && { color: '#E4933D' }),
//                                 ...(collapsed && {
//                                     width: 'fit-content',
//                                     margin: 'auto',
//                                     backgroundColor: 'transparent',
//                                 }),
//                             }}
//                             variant="text"
//                             to={path}
//                         >
//                             <Box>
//                                 {icon && (
//                                     <ListItemIcon
//                                         sx={{
//                                             color: path !== window.location.pathname ? 'white' : '#E4933D',
//                                             alignItems: 'center',
//                                             textAlign: 'center',
//                                             ...(collapsed && open && { borderRight: '2px solid #E4933D' }),
//                                         }}
//                                     >
//                                         {icon}
//                                     </ListItemIcon>
//                                 )}
//                             </Box>
//                             {!collapsed && (
//                                 <>
//                                     <Box sx={{ flexGrow: 1 }}>{label}</Box>
//                                     <Box
//                                         sx={{ marginRight: '10px' }}
//                                         onMouseLeave={() => setShowPopUp(false)}
//                                         onMouseEnter={() => setShowPopUp(true)}
//                                     >
//                                         {!isMobile && (
//                                             <IconButton size="small">
//                                                 <InfoOutlinedIcon
//                                                     sx={{ color: '#FFFFFF', width: '18px', height: '18px' }}
//                                                 />
//                                             </IconButton>
//                                         )}
//                                     </Box>
//                                     <Box
//                                         sx={{
//                                             display: showPopUp ? 'block' : 'none',
//                                             position: 'absolute',
//                                             backgroundColor: 'white',
//                                             color: 'black',
//                                             height: 'auto',
//                                             width: '220px',
//                                             zIndex: '1600',
//                                             p: '10px',
//                                             top: '35px',
//                                             borderRadius: '4px',
//                                             border: 1,
//                                             borderColor: 'text-default',
//                                         }}
//                                     >
//                                         <Typography sx={{ fontSize: '12px', fontWeight: '500' }}>{hover}</Typography>
//                                     </Box>
//                                 </>
//                             )}
//                             {info}
//                         </Button>
//                     </Box>
//                 </ListItem>
//                 {tooltip && (
//                     <Box
//                         sx={{
//                             display: !showPopUp && showTooltipKey === label ? 'block' : 'none',
//                             position: 'absolute',
//                             bgcolor: 'rgba(30,30,30,.8)',
//                             zIndex: '1600',
//                             p: '10px',
//                             borderRadius: '4px',
//                             color: 'white',
//                             fontSize: '10px',
//                             fontWeight: '500',
//                         }}
//                     >
//                         {tooltip}
//                     </Box>
//                 )}
//             </Box>
//         )
//     }
// }

// export default NavItem

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import type { ListItemProps } from '@mui/material'
import { Box, Button, Collapse, IconButton, ListItem, ListItemIcon, Typography } from '@mui/material'
import type { FC, ReactNode } from 'react'
import { useEffect, useState } from 'react'
import { NavLink as RouterLink } from 'react-router-dom'
import ChevronDownIcon from '../../icons/ChevronDown'
import ChevronUpIcon from '../../icons/ChevronUp'
import { useMemo } from 'react'
import { useTheme, Theme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'

interface NavItemProps extends ListItemProps {
    active?: boolean
    children?: ReactNode
    depth: number
    icon?: any
    info?: ReactNode
    open?: boolean
    path?: string
    label?: string
    hover?: string
    tooltip?: string
    collapsed?: boolean
    setCollapsed: any
}

const NavItem: FC<NavItemProps> = ({
    active = false,
    children,
    depth,
    icon,
    info,
    open: openProp = false,
    path,
    label,
    hover,
    collapsed,
    setCollapsed,
    tooltip,
    ...other
}) => {
    const [open, setOpen] = useState<boolean>(openProp)
    const [showPopUp, setShowPopUp] = useState(false)
    const handleToggle = (): void => setOpen((prevOpen) => !prevOpen)
    const [showTooltipKey, setShowTooltipKey] = useState<any>()
    const theme = useTheme<Theme>()
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

    if (children) {
        return (
            <Box sx={{ position: 'relative' }}>
                <ListItem
                    onClick={() => {
                        collapsed && setOpen(true)
                        setCollapsed(collapsed && false)
                    }}
                    disableGutters
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        py: 0,
                        width: '100%',
                        position: 'relative',
                        background: active ? '#132854' : 'transparent',
                        transition: 'background 0.2s',
                    }}
                    {...other}
                    onMouseEnter={() => setShowTooltipKey(label)}
                    onMouseLeave={() => setShowTooltipKey(null)}
                >
                    {/* Vertical bar for active state */}
                    <Box
                        sx={{
                            width: '3px',
                            height: '100%',
                            background: active ? '#E29346' : 'transparent',
                            position: 'absolute',
                            left: 0,
                            top: 0,
                            bottom: 0,
                            transition: 'background 0.2s',
                        }}
                    />
                    <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                        <Button
                            endIcon={!collapsed && (!open ? <ChevronDownIcon /> : <ChevronUpIcon />)}
                            onClick={handleToggle}
                            sx={{
                                display: 'flex',
                                gap: '10px',
                                fontWeight: 'fontWeightMedium',
                                justifyContent: 'center',
                                fontSize: '13px',
                                textAlign: 'left',
                                textTransform: 'none',
                                width: '100%',
                                alignItems: 'center',
                                ...(active && { color: '#E4933D' }),
                                ...(collapsed && {
                                    width: 'fit-content',
                                    margin: 'auto',
                                    backgroundColor: 'transparent',
                                }),
                            }}
                            variant="text"
                        >
                            <Box>
                                {icon && (
                                    <ListItemIcon
                                        sx={{
                                            color: !active ? 'white' : '#E4933D',
                                            alignItems: 'center',
                                            textAlign: 'center',
                                            ...(collapsed && active && { borderRight: '2px solid #E4933D' }),
                                        }}
                                    >
                                        {icon}
                                    </ListItemIcon>
                                )}
                            </Box>
                            {!collapsed && <Box sx={{ flexGrow: 1 }}>{label}</Box>}
                            {info}
                        </Button>
                    </Box>
                    {!collapsed && <Collapse in={open}>{children}</Collapse>}
                </ListItem>
                {tooltip && (
                    <Box
                        sx={{
                            display: showTooltipKey === label ? 'block' : 'none',
                            position: 'absolute',
                            bgcolor: 'rgba(30,30,30,.8)',
                            zIndex: '1600',
                            p: '10px',
                            borderRadius: '4px',
                            color: 'white',
                            fontSize: '10px',
                            fontWeight: '500',
                        }}
                    >
                        {tooltip}
                    </Box>
                )}
            </Box>
        )
    } else {
        return (
            <Box sx={{ position: 'relative' }}>
                <ListItem
                    disableGutters
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        py: 0,
                        position: 'relative',
                        background: active ? '#132854' : 'transparent',
                        transition: 'background 0.2s',
                    }}
                    {...other}
                    onMouseEnter={() => setShowTooltipKey(label)}
                    onMouseLeave={() => setShowTooltipKey(null)}
                >
                    {/* Vertical bar for active state */}
                    <Box
                        sx={{
                            width: '3px',
                            height: '100%',
                            background: active ? '#E29346' : 'transparent',
                            position: 'absolute',
                            left: 0,
                            top: 0,
                            bottom: 0,
                            transition: 'background 0.2s',
                        }}
                    />
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',

                            width: 'full',

                            // width: '100%',
                            // gap: 2,
                            paddingRight: isMobile ? '0px' : '4px', // Adjusted for mobile
                        }}
                    >
                        <Button
                            component={path && RouterLink}
                            sx={{
                                display: 'flex',
                                gap: '10px',
                                fontWeight: 'fontWeightMedium',
                                justifyContent: isMobile ? 'flex-start' : 'center', // Adjusted for mobile
                                fontSize: '13px',
                                textAlign: 'left',
                                textTransform: 'none',
                                width: '100%',
                                alignItems: 'center',
                                ...(path === window.location.pathname && { color: '#E4933D' }),
                                ...(collapsed && {
                                    width: 'fit-content',
                                    margin: 'auto',
                                    backgroundColor: 'transparent',
                                }),
                                ...(isMobile && {
                                    paddingLeft: '16px', // Added padding for mobile
                                }),
                            }}
                            variant="text"
                            to={path}
                        >
                            <Box>
                                {icon && (
                                    <ListItemIcon
                                        sx={{
                                            color: path !== window.location.pathname ? 'white' : '#E4933D',
                                            alignItems: 'center',
                                            textAlign: 'center',
                                            minWidth: isMobile ? '40px' : 'auto', // Adjusted for mobile
                                            ...(collapsed && open && { borderRight: '2px solid #E4933D' }),
                                        }}
                                    >
                                        {icon}
                                    </ListItemIcon>
                                )}
                            </Box>
                            {(!collapsed || isMobile) && ( // Always show label in mobile view
                                <>
                                    <Box
                                        sx={{
                                            flexGrow: 1,
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap',
                                        }}
                                    >
                                        {label}
                                    </Box>
                                    {!isMobile && (
                                        <Box
                                            sx={{ marginRight: '10px' }}
                                            onMouseLeave={() => setShowPopUp(false)}
                                            onMouseEnter={() => setShowPopUp(true)}
                                        >
                                            <IconButton size="small">
                                                <InfoOutlinedIcon
                                                    sx={{ color: '#FFFFFF', width: '18px', height: '18px' }}
                                                />
                                            </IconButton>
                                        </Box>
                                    )}
                                    {!isMobile && (
                                        <Box
                                            sx={{
                                                display: showPopUp ? 'block' : 'none',
                                                position: 'absolute',
                                                backgroundColor: 'white',
                                                color: 'black',
                                                height: 'auto',
                                                width: '220px',
                                                zIndex: '1600',
                                                p: '10px',
                                                top: '35px',
                                                borderRadius: '4px',
                                                border: 1,
                                                borderColor: 'text-default',
                                            }}
                                        >
                                            <Typography sx={{ fontSize: '12px', fontWeight: '500' }}>
                                                {hover}
                                            </Typography>
                                        </Box>
                                    )}
                                </>
                            )}
                            {info}
                        </Button>
                    </Box>
                </ListItem>
                {tooltip && (
                    <Box
                        sx={{
                            display: !showPopUp && showTooltipKey === label ? 'block' : 'none',
                            position: 'absolute',
                            bgcolor: 'rgba(30,30,30,.8)',
                            zIndex: '1600',
                            p: '10px',
                            borderRadius: '4px',
                            color: 'white',
                            fontSize: '10px',
                            fontWeight: '500',
                        }}
                    >
                        {tooltip}
                    </Box>
                )}
            </Box>
        )
    }
}

export default NavItem
